import React from "react";

const TableLoader = ({ colSpan }) => {
  return (
    <>
      {Array.from({ length: 5 }).map((_, index) => (
        <tr key={index}>
          <td colSpan={colSpan} className="py-3">
            <div className="bg-slate-200 animate-pulse w-full h-5"></div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default TableLoader;
